import React, { useState } from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Toolbar, IconButton } from "@mui/material";
import { 
  Dashboard, 
  Business, 
  Menu, 
  ChevronLeft, 
  Language, 
  Layers, 
  Contacts, 
  BarChart, 
  Settings, 
  Hotel, 
  Apartment, 
  LocationCity, 
  BrandingWatermark, 
  CalendarMonth, 
  ListAlt, 
  Assignment, 
  Pool, 
  Inventory,
  Stars 
} from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout as logoutAction } from "../Slices/auth";

const menuItems = [
  { text: "Organizations", icon: <Business />, path: "/organizations", color: "white" },
  { text: "Brands", icon: <BrandingWatermark />, path: "/brands", color: "white" },
  { text: "Channels", icon: <Language />, path: "/channels", color: "white" },
  { text: "Hotels", icon: <Hotel />, path: "/hotel", color: "white" },
  { text: "Contact", icon: <Contacts />, path: "/hotels_contact", color: "white" },
  { text: "Activity", icon: <Pool/>, path: "/activity", color: "white" },
  { text: "RoomTypes", icon: <Apartment />, path: "/roomtypes", color: "white" },
  { text: "Room Amenities", icon: <Hotel />, path: "/room-amenities", color: "white" },
  { text:"HotelActivityMapping",icon:<Assignment/>,path:"/HotelActivityMapping",color:"white"},
  { text: "Hotel Amenity Mapping", icon: <Hotel />, path: "/hotel-amenity-mapping", color: "white" },
  { text: "Hotel Reward Points", icon: <Stars />, path: "/HotelRewardPoints", color: "white" },
  { text: "Rate Plans", icon: <Layers />, path: "/plans", color: "white" },
  { text: "Rate Plan Channel", icon: <Layers />, path: "/Rate paln channel", color: "white" },
  { text: "Inventory Pools", icon: <Inventory />, path: "/bookinginventorypools", color: "white" },
  { text: "Booking Summary", icon: <ListAlt />, path: "/bookingsummary", color: "white" },
  { text: "Booking Activities", icon: <Assignment />, path: "/bookingactivities", color: "white" },
  { text: "Activity Pools", icon: <Pool />, path: "/bookingactivitypools", color: "white" },
];

const Sidebar = ({ open, handleDrawerToggle }) => {
  const location = useLocation();
  // Add hooks and logout handler
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      dispatch(logoutAction());
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
      alert("Logout failed. Please try again.");
    }
  };

  return (
    <Drawer variant="permanent" open={open} sx={{
      width: open ? 240 : 60,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: open ? 240 : 60,
        transition: "all 0.3s ease-in-out",
        backgroundColor: "#1a237e",
        borderRight: "none",
        boxShadow: "4px 0 10px rgba(0,0,0,0.1)",
        color: "#fff"
      }
    }}>
      {/* Wrap content in a flex column to stick logout to bottom */}
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Toolbar sx={{ 
          minHeight: "64px",
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "#151965"
        }}>
          <IconButton onClick={handleDrawerToggle} sx={{ color: "#fff" }}>
            {open ? <ChevronLeft /> : <Menu />}
          </IconButton>
        </Toolbar>
        <List sx={{ pt: 1, flexGrow: 1 }}>
          {menuItems.map((item, index) => (
            <ListItem
              button
              component={Link}
              to={item.path}
              key={index}
              sx={{
                mb: 0.5,
                mx: 1,
                borderRadius: 1,
                backgroundColor: location.pathname === item.path 
                  ? `${item.color}30`
                  : "transparent",
                color: location.pathname === item.path 
                  ? item.color 
                  : "#fff",
                '&:hover': {
                  backgroundColor: `${item.color}20`,
                  '& .MuiListItemIcon-root': {
                    color: item.color
                  }
                },
                transition: 'all 0.2s'
              }}
            >
              <ListItemIcon sx={{ 
                color: location.pathname === item.path 
                  ? item.color 
                  : "#fff",
                minWidth: 40,
                transition: 'all 0.2s'
              }}>
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText 
                  primary={item.text} 
                  sx={{
                    '& .MuiTypography-root': {
                      fontWeight: location.pathname === item.path ? 600 : 400
                    }
                  }}
                />
              )}
            </ListItem>
          ))}
        </List>
        {/* Add bottom-sticky logout item */}
        <List sx={{ pb: 1 }}>
          <ListItem
            button
            onClick={handleLogout}
            sx={{
              mx: 1,
              mb: 0.5,
              borderRadius: 1,
              color: "#fff",
              '&:hover': {
                backgroundColor: `white20`,
                '& .MuiListItemIcon-root': {
                  color: "white"
                }
              },
              transition: 'all 0.2s'
            }}
          >
            <ListItemIcon sx={{ color: "#fff", minWidth: 40 }}>
              <LogoutIcon />
            </ListItemIcon>
            {open && <ListItemText primary="Logout" />}
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
};

export default Sidebar;
